var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "box",
    { attrs: { background: "white", "no-shadow": "" } },
    [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c(
            "v-btn",
            {
              staticClass: "expand-altitude-btn",
              staticStyle: { float: "right", "margin-top": "0" },
              attrs: {
                small: "",
                icon: "",
                title: _vm.$t("altitudePreview.expandAltitudeChart")
              },
              on: {
                click: function($event) {
                  return _vm.openAltitudeBox()
                }
              }
            },
            [_c("v-icon", [_vm._v("open_in_new")])],
            1
          ),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("altitudePreview.altitude")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("altitude", {
        attrs: { height: _vm.height, "map-view-data": _vm.mapViewData }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8ab0fdc", { render: render, staticRenderFns: staticRenderFns })
  }
}